import React from 'react'
import Stack from '../../Component/Stack'
import Jumbotron from '../../Component/Jumbotron'

const Techs = () => {
    return (
        <>
            <Jumbotron height={40} message={'Techs'}/>
            <Stack />
        </>
    )
}

export default Techs